import MyTextEllipsis from './MyTextEllipsis/index.vue'
import MyEditor from './MyEditor/index.vue'

const myTextEllipsis = {
    install: function(Vue){
        Vue.component('MyTextEllipsis',MyTextEllipsis)
    }
};
const myEditor = {
    install: function(Vue){
        Vue.component('MyEditor',MyEditor)
    }
};


// 导出组件
export {myTextEllipsis,myEditor}